import type { Product } from '@hotjar/service-management';
import type { ProductAllowance } from '..';

export function mapServiceProductToProductAllowance({ entity, sku }: Product): ProductAllowance {
  return {
    sku,
    entity: {
      entityIdentifier: entity.id,
      entityLabel: entity.label,
      entityType: entity.type,
    },
  };
}
